var _circle, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClimateControl32 = function SvgClimateControl32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 24,
    r: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 10h2v11h-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 2,
    height: 12,
    rx: 1,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a3.602 3.602 0 0 0-2.57 1.09 3.761 3.761 0 0 0-1.067 2.626v13.278a6.133 6.133 0 0 0-2.1 3.082 6.256 6.256 0 0 0 .052 3.755 6.122 6.122 0 0 0 2.186 3.019A5.914 5.914 0 0 0 12 30a5.914 5.914 0 0 0 3.499-1.15 6.122 6.122 0 0 0 2.186-3.02 6.257 6.257 0 0 0 .052-3.754 6.133 6.133 0 0 0-2.1-3.082V5.737a3.761 3.761 0 0 0-1.067-2.626A3.602 3.602 0 0 0 12 2.021V2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11h8m-8 4h8m-8-8h8",
    stroke: "currentColor",
    strokeWidth: 2.091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgClimateControl32;